import React, { useEffect, useState } from "react";
import { uploadToS3 } from "../../constents/UploadToS3";
import axiosInstance from "../../constents/axios";
const Certificate = () => {
  const [image, setImage] = useState(false);
  const [program, setProgram] = useState("");
  const [validWorkshops, setValidWorkshops] = useState([]);
  const [alert, setAlert] = useState("");
  const [progress, setProgress] = useState(0);
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [create, setCreate] = useState(false);
  const [existProgramByCourseid, setExistProgramByCourseid] = useState([]);
  const HandleProgress = (value) => {
    setProgress(value);
  };
  const HandleImage = (e) => {
    setAlert("");
    try {
      const file = e.target.files[0];
      setImage(file);
      if (file) {
        const maxSize = 1048576; // 1 MB in bytes
        if (file.size > maxSize) {
          setAlert("File size exceeds 1 MB. Please choose a smaller file.");
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const HandleProgramSelection = (e) => {
    try {
      setProgram(e.target.value);
    } catch (error) {
      console.log(error);
    }
  };
  const handleStartChange = (e) => {
    setStartDateTime(e.target.value);
  };

  const handleEndChange = (e) => {
    setEndDateTime(e.target.value);
  };

  const handleChange = () => {
    console.log("isChecked", isChecked);

    setIsChecked(!isChecked);
  };
  const HandleSubmit = async (e) => {
    e.preventDefault();
    if (alert) {
      return;
    }
    try {
      if (!image || !program) {
        return;
      }
      const update = await uploadToS3(image, "Certificate", HandleProgress);
      console.log(update, "upate");
      if (update.status) {
        const data = {
          program: validWorkshops[program].title,
          course_id: validWorkshops[program].course_id,
          template_image: update.location,
          start_date: startDateTime,
          end_date: endDateTime,
          status: isChecked ? 1 : 0,
        };
        const createProgram = await axiosInstance.post(
          `/api/create-certificate-program`,
          data
        );
        console.log(createProgram, "createProgram");
        if (createProgram.data.status) {
          setEndDateTime("");
          setProgram("");
          setStartDateTime("");
          setProgress(0);
          setCreate(false);
        } else {
          setAlert(createProgram.data.error.parent.sqlMessage);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getAllValidWorkshops = async (endpoint) => {
    const cleaned = endpoint.replace(/%20/g, " ");
    const { data } = await axiosInstance.get(
      `/get-title-by-course_id/${cleaned}`
    );
    if (data.status) {
      setValidWorkshops(data.data);
    }
    const getExistProgram = await axiosInstance.get(
      `/api/get-certificate-program-by-courseid/${cleaned}`
    );
    console.log(getExistProgram, "getExistProgram");
    console.log(getExistProgram.data.data, "getExistProgram.data.data");

    if (getExistProgram.data.status) {
      setExistProgramByCourseid(getExistProgram.data.data);
    }
  };
  useEffect(() => {
    const parts = window.location.pathname.split("/");
    let endpoint = parts[parts.length - 1];
    getAllValidWorkshops(endpoint);
  }, []);
  const handleBackButton = () => {
    window.location.replace("/certificate");
  };

  console.log(existProgramByCourseid,"//////");

  return (
    <div>
      <button
        className=" mb-5 btn btn-outline-primary btn-sm"
        onClick={handleBackButton}
      >
        <i className="fa fa-arrow-left" aria-hidden="true"></i> back
      </button>
      {create && (
        <div className="container ">
          <h1>
            <strong>Upload template certificate</strong>
          </h1>
          <form onSubmit={HandleSubmit} className="row m-5 d-flex">
            <div className="col-12 col-md-8">
              <label htmlFor="templateImage" className="my-2">
                Please upload a template image
              </label>
              <br />
              <input
                type="file"
                id="templateImage"
                onChange={HandleImage}
                className="form-control"
                accept=".jpeg, .jpg"
                required
              />
            </div>

            <div className="col-12 col-md-8 my-3">
              <select
                onChange={HandleProgramSelection}
                className="form-control"
                required
              >
                <option value="">Please select program</option>
                {validWorkshops.map((value, index) => (
                  <option value={index} key={index}>
                    {value.title}
                  </option>
                ))}
              </select>
              {alert && <p className="text-danger my-2">{alert}</p>}
              {progress > 0 && (
                <div className="progress my-3">
                  <div
                    className="progress-bar progress-bar-striped bg-primary progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
              )}
            </div>

            <div className="col-12 col-md-6">
              <div className="mb-3">
                <label className="form-label">Start Date & Time</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={startDateTime}
                  onChange={handleStartChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">End Date & Time</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={endDateTime}
                  onChange={handleEndChange}
                  required
                />
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="flexSwitchCheckDefault">Program Status</label>
              <br />
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked={isChecked}
                  onChange={handleChange}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  {isChecked ? "Active" : "Inactive"}
                </label>
              </div>
            </div>

            <div className="col-8 text-center">
              <button
                type="submit"
                className="btn btn-success w-50"
                disabled={alert}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      )}

      {!create && (
        <div className="container">
          <h2>Programs and certificates</h2>
          <div className="row">
          <div className="col-12">
              <button className="btn btn-info" onClick={() => setCreate(true)}>
                Create new certificate program
              </button>
            </div>
          </div>
          <div className="row py-3">
            <h3>Current Programs</h3>
            <div className="col-12">
              <table class="table table-sm table-bordered table-responsive">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Program</th>
                    <th scope="col">Template image</th>
                    <th scope="col">start date</th>
                    <th scope="col">end date</th>
                    <th scope="col">status</th>
                    <th scope="col">Action</th>

                  </tr>
                </thead>
                <tbody>
                  {existProgramByCourseid.length > 0 &&
                    existProgramByCourseid.map((value, index) => {
                      return (
                        <tr key={index}>
                          <th scope="row">{index + 1}</th>
                          <td>{value.program}</td>
                          <td>
                            <img src={value.template_image} alt="template" className="img-fluid"  style={{width:"200px"}}/>
                          </td>
                          <td>{value.start_date}</td>
                          <td>{value.end_date}</td>
                          <td>{value.status ? "Active":"Inactive"}</td>
                          <td>
                            <button className="btn btn-sm btn-outline-danger my-2"><i class="fa fa-solid fa-trash"></i></button> <br />
                            <button className="btn btn-sm btn-outline-primary my-2"><i class="fa fa-solid fa-edit"></i></button> <br />
                            </td>

                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
           
            <div className="col"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Certificate;
